/* ============================================================
   Alatreyu Header — JavaScript
   Scroll behavior, megamenu pagination & positioning,
   mobile drawer, :has() fallback.
   Ported from prototype shared.js
   ============================================================ */

(function () {
  'use strict';

  function isSafeUrl(url) {
    if (!url) return false;
    return /^https?:\/\//i.test(url) || /^\//.test(url);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeaderScroll();
    initMegamenu();
    initMegamenuFilter();
    initMegamenuPairings();
    initMobileDrawer();
    initHasFallback();
    initHomepageCartVisibility();
    initGiftCardPickers();
    initGiftCardForms();
    initMobileGiftCardModal();
    initHeaderSearch();
  });

  /* --- Header Scroll Behavior -------------------------------- */
  function initHeaderScroll() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var isHomepage = header.classList.contains('on-homepage');
    var heroEl = isHomepage ? document.querySelector('[data-homepage-hero]') : null;

    window.addEventListener('scroll', function () {
      if (window.scrollY > 60) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }

      /* On homepage: reveal full header after scrolling past hero */
      if (isHomepage && heroEl) {
        var heroBottom = heroEl.getBoundingClientRect().bottom;
        if (heroBottom <= 0) {
          header.classList.add('homepage-header-visible');
        } else {
          header.classList.remove('homepage-header-visible');
        }
      }
    }, { passive: true });
  }

  /* --- Megamenu Positioning ----------------------------------- */
  function initMegamenu() {
    var megamenu = document.querySelector('.megamenu');
    if (!megamenu) return;

    /* Position megamenu + hover intent (safe-triangle pattern).
       A 300ms delay before closing gives the user time to move
       their mouse diagonally from the nav trigger to the megamenu
       without accidentally closing it. */
    var navItem = document.querySelector('.nav-item');
    var header = document.querySelector('.site-header');
    var hideTimer = null;
    var HIDE_DELAY = 300;

    function showMega() {
      clearTimeout(hideTimer);
      var headerRect = header.getBoundingClientRect();
      megamenu.style.top = headerRect.bottom + 'px';
      megamenu.classList.add('megamenu--open');
      header.classList.add('scrolled');
      header.classList.add('megamenu-open');
    }

    function scheduleHide() {
      hideTimer = setTimeout(function () {
        /* Don't close while the gift card form is being used */
        if (megamenu.classList.contains('megamenu--form-active')) return;
        /* Don't close while an input inside the megamenu has focus */
        if (megamenu.contains(document.activeElement) &&
            document.activeElement.tagName !== 'BODY') {
          return;
        }
        megamenu.classList.remove('megamenu--open');
        header.classList.remove('megamenu-open');
        if (window.scrollY <= 60) {
          header.classList.remove('scrolled');
        }
      }, HIDE_DELAY);
    }

    if (navItem && header) {
      navItem.addEventListener('mouseenter', showMega);
      navItem.addEventListener('mouseleave', scheduleHide);

      megamenu.addEventListener('mouseenter', function () {
        clearTimeout(hideTimer);
      });
      megamenu.addEventListener('mouseleave', scheduleHide);

      /* Keep megamenu open while any input inside it has focus */
      megamenu.addEventListener('focusin', function () {
        clearTimeout(hideTimer);
      });
      megamenu.addEventListener('focusout', function (e) {
        if (!megamenu.contains(e.relatedTarget)) {
          scheduleHide();
        }
      });

      /* Track gift card form interaction — set form-active class while
         any form input has focus. 500ms grace period after blur handles
         the gap when the native date picker closes before next focus. */
      var gcForm = megamenu.querySelector('[data-gift-card-form]');
      if (gcForm) {
        var formActiveTimer;
        gcForm.addEventListener('focusin', function () {
          clearTimeout(formActiveTimer);
          megamenu.classList.add('megamenu--form-active');
        });
        gcForm.addEventListener('focusout', function () {
          formActiveTimer = setTimeout(function () {
            megamenu.classList.remove('megamenu--form-active');
          }, 500);
        });
      }
    }
  }

  /* --- Megamenu Fragrance Filter ------------------------------ */
  function initMegamenuFilter() {
    var filterGroups = document.querySelectorAll('[data-filter-group]');
    var fragranceLinks = document.querySelectorAll('.megamenu__fragrance-link');
    if (!filterGroups.length || !fragranceLinks.length) return;

    /* Track active filter per group */
    var activeFilters = { category: 'all', strength: 'all' };

    function applyFilters() {
      var catFilter = activeFilters.category;
      var strFilter = activeFilters.strength;

      /* If both are "all", clear all styling */
      if (catFilter === 'all' && strFilter === 'all') {
        fragranceLinks.forEach(function (link) {
          link.classList.remove('dimmed', 'highlight');
        });
        return;
      }

      fragranceLinks.forEach(function (link) {
        var catMatch = true;
        var strMatch = true;

        /* Check category filter */
        if (catFilter !== 'all') {
          catMatch = false;
          if (catFilter === 'best-seller' && link.hasAttribute('data-best-seller')) catMatch = true;
          if (catFilter === 'new' && link.hasAttribute('data-new')) catMatch = true;
        }

        /* Check strength filter */
        if (strFilter !== 'all') {
          strMatch = link.getAttribute('data-strength') === strFilter;
        }

        if (catMatch && strMatch) {
          link.classList.add('highlight');
          link.classList.remove('dimmed');
        } else {
          link.classList.add('dimmed');
          link.classList.remove('highlight');
        }
      });
    }

    filterGroups.forEach(function (group) {
      var groupName = group.getAttribute('data-filter-group');
      var btns = group.querySelectorAll('.megamenu__filter-btn');

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          /* Toggle active within this group only */
          btns.forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');

          activeFilters[groupName] = btn.getAttribute('data-filter');
          applyFilters();
        });
      });
    });
  }

  /* --- Megamenu Fragrance Pairings ----------------------------- */
  function initMegamenuPairings() {
    var grid = document.querySelector('.megamenu__fragrance-grid');
    var filtersDiv = document.querySelector('.megamenu__filters');
    if (!grid) return;

    var links = grid.querySelectorAll('.megamenu__fragrance-link[data-fragrance]');
    if (!links.length) return;

    /* Edge list: pairs of Shopify product handles that pair well together */
    var EDGES = [
      ['petrichor', 'creosote'],
      ['petrichor', 'ozone'],
      ['petrichor', 'rain-on-pavement'],
      ['petrichor', 'biblichor'],
      ['petrichor', 'pine'],
      ['petrichor', 'leaves'],
      ['creosote', 'sagebrush'],
      ['pine', 'bonfire'],
      ['pine', 'woodshop'],
      ['hay-field', 'sandstone'],
      ['tomato-vine', 'hydrangea'],
      ['tomato-vine', 'cut-grass'],
      ['ozone', 'rain-on-pavement'],
      ['ocean', 'ozone'],
      ['ocean', 'sandstone'],
      ['hydrangea', 'cut-grass'],
      ['leaves', 'bonfire']
    ];

    /* Build adjacency map */
    var adj = {};
    EDGES.forEach(function (edge) {
      if (!adj[edge[0]]) adj[edge[0]] = [];
      if (!adj[edge[1]]) adj[edge[1]] = [];
      adj[edge[0]].push(edge[1]);
      adj[edge[1]].push(edge[0]);
    });

    /* Build handle → element map */
    var handleMap = {};
    links.forEach(function (link) {
      handleMap[link.getAttribute('data-fragrance')] = link;
    });

    /* Create legend element inside filters bar */
    var legend = document.createElement('div');
    legend.className = 'megamenu__pair-legend';
    legend.innerHTML = '<span class="megamenu__pair-legend-swatch"></span> Pairs well together';
    if (filtersDiv) {
      filtersDiv.appendChild(legend);
    }

    var currentHover = null;
    var clearTimer = null;

    function clearPairings() {
      currentHover = null;
      legend.classList.remove('visible');
      links.forEach(function (link) {
        link.classList.remove('pair-highlight');
      });
    }

    function scheduleClear() {
      clearTimer = setTimeout(clearPairings, 120);
    }

    function showPairings(handle) {
      var neighbors = adj[handle];
      if (!neighbors || !neighbors.length) return;

      /* Only highlight neighbors that aren't dimmed by a filter */
      var anyShown = false;
      neighbors.forEach(function (neighbor) {
        if (handleMap[neighbor] && !handleMap[neighbor].classList.contains('dimmed')) {
          handleMap[neighbor].classList.add('pair-highlight');
          anyShown = true;
        }
      });

      if (anyShown) {
        currentHover = handle;
        legend.classList.add('visible');
      }
    }

    /* Hover listeners on each fragrance link */
    links.forEach(function (link) {
      link.addEventListener('mouseenter', function () {
        clearTimeout(clearTimer);
        var handle = link.getAttribute('data-fragrance');
        if (currentHover === handle) return;
        clearPairings();
        showPairings(handle);
      });

      link.addEventListener('mouseleave', scheduleClear);
    });

    /* Clear when mouse leaves the grid */
    grid.addEventListener('mouseleave', function () {
      clearPairings();
    });
  }

  /* --- Mobile Drawer ----------------------------------------- */
  function initMobileDrawer() {
    var toggle = document.querySelector('.mobile-menu-toggle');
    var drawer = document.getElementById('mobile-drawer');
    if (!toggle || !drawer) return;

    var backdrop = drawer.querySelector('.mobile-drawer__backdrop');
    var closeBtn = drawer.querySelector('.mobile-drawer__close');

    function openDrawer() {
      drawer.setAttribute('aria-hidden', 'false');
      toggle.classList.add('open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      toggle.classList.remove('open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', function () {
      var isOpen = drawer.getAttribute('aria-hidden') === 'false';
      if (isOpen) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    if (backdrop) backdrop.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      }
    });
  }

  /* --- CSS :has() Fallback ------------------------------------ */
  function initHasFallback() {
    /* Test if the browser supports :has(). If not, add .megamenu-open
       class on mouseenter/mouseleave for the same visual effect. */
    var supported = false;
    try {
      supported = CSS.supports('selector(:has(*))');
    } catch (e) {
      supported = false;
    }

    if (supported) return; /* Modern browser — CSS :has() handles it */

    var navItem = document.querySelector('.nav-item');
    var header = document.querySelector('.site-header');
    if (!navItem || !header) return;

    navItem.addEventListener('mouseenter', function () {
      header.classList.add('megamenu-open');
    });
    navItem.addEventListener('mouseleave', function () {
      header.classList.remove('megamenu-open');
    });

    var megamenu = document.querySelector('.megamenu');
    if (megamenu) {
      megamenu.addEventListener('mouseenter', function () {
        header.classList.add('megamenu-open');
      });
      megamenu.addEventListener('mouseleave', function () {
        header.classList.remove('megamenu-open');
      });
    }
  }

  /* --- Homepage Cart Visibility -------------------------------- */
  function initHomepageCartVisibility() {
    var header = document.querySelector('.site-header.on-homepage');
    if (!header) return; /* Not on homepage — nothing to do */

    var cartIcon = header.querySelector('[data-cart-icon]');
    if (!cartIcon) return;

    /* Watch for cart count changes from PWYC or other scripts.
       They update [data-cart-count] text content after /cart/add.js calls. */
    var badge = cartIcon.querySelector('[data-cart-count]');
    if (!badge) return;

    var observer = new MutationObserver(function () {
      var count = parseInt(badge.textContent, 10) || 0;
      if (count > 0) {
        cartIcon.classList.remove('cart-icon--hidden');
      } else {
        cartIcon.classList.add('cart-icon--hidden');
      }
    });

    observer.observe(badge, { childList: true, characterData: true, subtree: true });
  }

  /* --- Gift Card Horizontal Pickers ----------------------------- */
  function initGiftCardPickers() {
    var pickers = document.querySelectorAll('[data-gift-picker]');
    pickers.forEach(function (picker) {
      var tiers = picker.querySelectorAll('[data-picker-tier]');
      var track = picker.querySelector('[data-picker-track]');
      var prevBtn = picker.querySelector('[data-picker-prev]');
      var nextBtn = picker.querySelector('[data-picker-next]');
      var windowEl = picker.querySelector('[data-picker-window]');
      if (!tiers.length || !track || !windowEl) return;

      var totalTiers = tiers.length;

      /* Find default index (the tier with --active class, fallback to 1 for $25) */
      var currentIndex = 1;
      tiers.forEach(function (t, i) {
        if (t.classList.contains('gift-picker__tier--active')) currentIndex = i;
      });

      /* Find the associated form's hidden variant ID input */
      var form = picker.closest('[data-gift-card-form]');
      var variantInput = form ? form.querySelector('[data-gc-variant-id]') : null;

      /* Size each tier to 1/3 of the visible window width */
      function sizeTiers() {
        var w = windowEl.offsetWidth / 3;
        tiers.forEach(function (t) { t.style.width = w + 'px'; });
      }

      function updatePicker(newIndex) {
        if (newIndex < 0 || newIndex >= totalTiers) return;
        currentIndex = newIndex;

        /* Move track so active tier is centered in the 3-slot window */
        var tierWidth = tiers[0].offsetWidth;
        var offset = (1 - currentIndex) * tierWidth;
        track.style.transform = 'translateX(' + offset + 'px)';

        /* Update active class */
        tiers.forEach(function (t, i) {
          if (i === currentIndex) {
            t.classList.add('gift-picker__tier--active');
          } else {
            t.classList.remove('gift-picker__tier--active');
          }
        });

        if (window.AlatreyuHaptics) window.AlatreyuHaptics('tap');

        /* Update hidden variant input */
        if (variantInput) {
          variantInput.value = tiers[currentIndex].getAttribute('data-variant-id');
        }
      }

      /* Arrow buttons */
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          updatePicker(currentIndex - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          updatePicker(currentIndex + 1);
        });
      }

      /* Click on a tier to select it */
      tiers.forEach(function (tier, i) {
        tier.addEventListener('click', function () {
          updatePicker(i);
        });
      });

      /* Mouse wheel on the picker (vertical scroll = horizontal navigation) */
      picker.addEventListener('wheel', function (e) {
        e.preventDefault();
        if (e.deltaY > 0 || e.deltaX > 0) {
          updatePicker(currentIndex + 1);
        } else if (e.deltaY < 0 || e.deltaX < 0) {
          updatePicker(currentIndex - 1);
        }
      }, { passive: false });

      /* Touch swipe support (horizontal) */
      var touchStartX = 0;
      picker.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      picker.addEventListener('touchend', function (e) {
        var deltaX = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(deltaX) > 20) {
          if (deltaX > 0) {
            updatePicker(currentIndex + 1);
          } else {
            updatePicker(currentIndex - 1);
          }
        }
      }, { passive: true });

      /* Initialize: size tiers and center on default ($25) */
      sizeTiers();
      updatePicker(currentIndex);

      /* Re-size tiers when modal becomes visible (fixes 0-width issue
         when picker is inside a hidden modal at page load) */
      var modal = picker.closest('[data-mobile-gc-modal]');
      if (modal) {
        var visObserver = new MutationObserver(function () {
          if (modal.getAttribute('aria-hidden') === 'false') {
            sizeTiers();
            updatePicker(currentIndex);
          }
        });
        visObserver.observe(modal, { attributes: true, attributeFilter: ['aria-hidden'] });
      }

      /* Desktop megamenu: re-size when megamenu becomes visible on hover
         (fixes 0-width issue when picker initializes while megamenu is hidden) */
      var megamenu = picker.closest('.megamenu');
      if (megamenu) {
        var navItem = megamenu.closest('.nav-item');
        if (navItem) {
          navItem.addEventListener('mouseenter', function () {
            sizeTiers();
            updatePicker(currentIndex);
          });
        }
      }
    });
  }

  /* --- Gift Card Form Submission (AJAX /cart/add.js) ----------- */
  function initGiftCardForms() {
    var forms = document.querySelectorAll('[data-gift-card-form]');
    forms.forEach(function (form) {
      /* Set timezone offset for Shopify scheduling */
      var offsetInput = form.querySelector('[data-gc-timezone-offset]');
      if (offsetInput) {
        offsetInput.value = new Date().getTimezoneOffset().toString();
      }

      /* Set min date on "Send on" field to today, max to +90 days */
      var dateInput = form.querySelector('[data-gc-send-on]');
      if (dateInput) {
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        var maxDate = new Date();
        maxDate.setDate(maxDate.getDate() + 90);
        dateInput.setAttribute('min', formatDate(tomorrow));
        dateInput.setAttribute('max', formatDate(maxDate));
      }

      /* Delivery toggle (Today vs. Pick a date) */
      var deliverySection = form.querySelector('[data-gc-delivery]');
      var isMobileModal = !!form.closest('[data-mobile-gc-modal]');
      if (deliverySection) {
        var todayBtn = deliverySection.querySelector('[data-gc-delivery-today]');
        var customBtn = deliverySection.querySelector('[data-gc-delivery-custom]');
        var dateWrap = deliverySection.querySelector('[data-gc-delivery-date-wrap]');

        if (todayBtn && customBtn && dateWrap) {
          if (isMobileModal) {
            /* Move dateWrap inside delivery-options so it overlays
               the "Pick a date" button (CSS positions it absolutely) */
            var optionsDiv = deliverySection.querySelector('.gift-card-form__delivery-options');
            if (optionsDiv) {
              dateWrap.style.display = '';
              optionsDiv.appendChild(dateWrap);
            }

            /* When user taps the transparent date input (overlaying
               "Pick a date"), mark the custom button as active */
            if (dateInput) {
              dateInput.addEventListener('click', function () {
                customBtn.classList.add('active');
                todayBtn.classList.remove('active');
              });

              dateInput.addEventListener('change', function () {
                if (dateInput.value) {
                  var parts = dateInput.value.split('-');
                  var d = new Date(parts[0], parts[1] - 1, parts[2]);
                  customBtn.textContent = d.toLocaleDateString('en-US', {
                    month: 'short', day: 'numeric', year: 'numeric'
                  });
                  customBtn.classList.add('active');
                  todayBtn.classList.remove('active');
                } else {
                  customBtn.textContent = 'Pick a date';
                }
              });
            }

            todayBtn.addEventListener('click', function () {
              todayBtn.classList.add('active');
              customBtn.classList.remove('active');
              if (dateInput) dateInput.value = '';
              customBtn.textContent = 'Pick a date';
            });
          } else {
            /* Desktop: original show/hide behavior */
            todayBtn.addEventListener('click', function () {
              todayBtn.classList.add('active');
              customBtn.classList.remove('active');
              dateWrap.style.display = 'none';
              if (dateInput) dateInput.value = '';
            });

            customBtn.addEventListener('click', function () {
              customBtn.classList.add('active');
              todayBtn.classList.remove('active');
              dateWrap.style.display = '';
              if (dateInput) {
                dateInput.focus();
                try { dateInput.showPicker(); } catch (e) { /* older browsers */ }
              }
            });
          }
        }
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var submitBtn = form.querySelector('.gift-card-form__submit');
        var feedback = form.querySelector('[data-gc-feedback]');
        if (!submitBtn) return;

        /* Clear previous feedback */
        if (feedback) {
          feedback.textContent = '';
          feedback.className = 'gift-card-form__feedback';
        }

        /* Disable button during request */
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';

        /* Build the form data as JSON for /cart/add.js */
        var formData = new FormData(form);
        var body = {};
        body.id = parseInt(formData.get('id'), 10);
        body.quantity = 1;
        body.properties = {};
        formData.forEach(function (value, key) {
          if (key === 'id' || key === 'quantity') return;
          if (key.indexOf('properties[') === 0) {
            var propKey = key.replace('properties[', '').replace(']', '');
            if (value !== '') {
              body.properties[propKey] = value;
            }
          }
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: body.id,
              quantity: 1,
              properties: body.properties
            }]
          })
        })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (data) {
              throw new Error(data.description || 'Could not add to cart');
            });
          }
          return res.json();
        })
        .then(function () {
          /* Success */
          submitBtn.textContent = 'Added!';
          updateCartBadge();

          /* Brief flash, then close modal & open cart drawer */
          setTimeout(function () {
            /* Close mobile gift card modal if open */
            var gcModal = form.closest('[data-mobile-gc-modal]');
            if (gcModal) {
              gcModal.setAttribute('aria-hidden', 'true');
              document.body.style.overflow = '';
            }

            /* Open cart drawer to show the added gift card */
            if (window.AlatreyuCartDrawer) {
              window.AlatreyuCartDrawer.openAfterRefresh();
            }

            /* Reset form */
            form.reset();
            submitBtn.disabled = false;
            submitBtn.textContent = 'Add to Cart';
            if (feedback) {
              feedback.textContent = '';
              feedback.className = 'gift-card-form__feedback';
            }
            if (offsetInput) {
              offsetInput.value = new Date().getTimezoneOffset().toString();
            }
            if (isMobileModal && customBtn) {
              customBtn.textContent = 'Pick a date';
              customBtn.classList.remove('active');
            }
            if (todayBtn) todayBtn.classList.add('active');
          }, 600);
        })
        .catch(function (err) {
          if (feedback) {
            feedback.textContent = err.message;
            feedback.className = 'gift-card-form__feedback gift-card-form__feedback--error';
          }
          submitBtn.disabled = false;
          submitBtn.textContent = 'Add to Cart';
        });
      });
    });
  }

  /* --- Mobile Gift Card Modal ---------------------------------- */
  function initMobileGiftCardModal() {
    var modal = document.querySelector('[data-mobile-gc-modal]');
    if (!modal) return;

    var backdrop = modal.querySelector('[data-mobile-gc-backdrop]');
    var closeBtn = modal.querySelector('[data-mobile-gc-close]');
    var openBtns = document.querySelectorAll('[data-open-mobile-gc]');

    function openModal() {
      /* Close mobile drawer first */
      var drawer = document.getElementById('mobile-drawer');
      var toggle = document.querySelector('.mobile-menu-toggle');
      if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
        drawer.setAttribute('aria-hidden', 'true');
        if (toggle) {
          toggle.classList.remove('open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      }

      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function (btn) {
      btn.addEventListener('click', openModal);
    });

    if (backdrop) backdrop.addEventListener('click', closeModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });
  }

  /* --- Header Search ------------------------------------------- */
  function initHeaderSearch() {
    var toggleBtns = document.querySelectorAll('[data-search-toggle]');
    var searchBar = document.querySelector('[data-search-bar]');
    var searchInput = document.querySelector('[data-search-input]');
    var searchClose = document.querySelector('[data-search-close]');
    var resultsContainer = document.querySelector('[data-search-results]');
    var header = document.querySelector('.site-header');
    if (!searchBar || !searchInput || !resultsContainer) return;

    /* Load fragrance data from embedded JSON */
    var fragrances = [];
    var dataEl = document.getElementById('search-fragrance-data');
    if (dataEl) {
      try { fragrances = JSON.parse(dataEl.textContent); } catch (e) { /* ignore */ }
    }
    if (!fragrances.length) return;

    var isOpen = false;
    var nav = document.querySelector('.header-nav');

    /* Toggle the search icon between magnifying glass and X */
    var searchIconBtn = nav ? nav.querySelector('.header-search-icon') : null;
    function setSearchIconState(open) {
      if (!searchIconBtn) return;
      var svg = searchIconBtn.querySelector('svg');
      if (!svg) return;
      if (open) {
        svg.innerHTML = '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>';
        searchIconBtn.setAttribute('aria-label', 'Close search');
      } else {
        svg.innerHTML = '<circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>';
        searchIconBtn.setAttribute('aria-label', 'Search fragrances');
      }
    }

    function openSearch() {
      isOpen = true;
      searchBar.setAttribute('aria-hidden', 'false');
      setSearchIconState(true);

      /* Position search bar in the gap between logo and search icon */
      if (header && nav) {
        var headerRect = header.getBoundingClientRect();
        var searchIcon = nav.querySelector('.header-search-icon');
        var logoEl = document.querySelector('.site-logo');
        if (searchIcon && logoEl) {
          var iconRect = searchIcon.getBoundingClientRect();
          var logoRect = logoEl.getBoundingClientRect();
          var gapWidth = iconRect.left - logoRect.right - 24;
          /* Cap bar width at 360px, anchor right edge near the search icon */
          var barWidth = Math.min(gapWidth, 360);
          if (barWidth > 120) {
            var barRight = headerRect.right - iconRect.left + 8;
            searchBar.style.right = barRight + 'px';
            searchBar.style.width = barWidth + 'px';
            searchBar.style.left = 'auto';
          }
        }
        resultsContainer.style.top = headerRect.bottom + 'px';
        nav.classList.add('search-open');
      }

      /* Start with no results — they appear as user types */
      hideResultsPanel();
      setTimeout(function () { searchInput.focus(); }, 100);
    }

    function closeSearch() {
      isOpen = false;
      searchBar.setAttribute('aria-hidden', 'true');
      setSearchIconState(false);
      hideResultsPanel();
      searchInput.value = '';
      if (nav) nav.classList.remove('search-open');
    }

    var MAX_NAV_RESULTS = 3;

    var blurOverlay = document.querySelector('.search-blur-overlay');

    function showResultsPanel() {
      resultsContainer.setAttribute('aria-hidden', 'false');
      if (header) header.classList.add('search-results-open');
      if (blurOverlay) blurOverlay.classList.add('active');
    }

    function hideResultsPanel() {
      resultsContainer.setAttribute('aria-hidden', 'true');
      if (header) header.classList.remove('search-results-open');
      if (blurOverlay) blurOverlay.classList.remove('active');
    }

    function renderResultCard(item) {
      var label = escapeHtml(item.name) + (item.notes ? ' — ' + escapeHtml(item.notes) : '');
      var h = '<a class="search-result" href="' + item.url + '" role="listitem" aria-label="' + label + '">';
      h += '<div class="search-result__media">';
      if (item.video && isSafeUrl(item.video)) {
        h += '<video autoplay muted loop playsinline aria-hidden="true"><source src="' + escapeHtml(item.video) + '" type="video/mp4"></video>';
      } else if (item.img && isSafeUrl(item.img)) {
        h += '<img src="' + escapeHtml(item.img) + '" alt="' + escapeHtml(item.name) + '" loading="lazy">';
      }
      h += '</div>';
      h += '<div class="search-result__name">' + escapeHtml(item.name) + '</div>';
      if (item.notes) {
        h += '<div class="search-result__notes">' + escapeHtml(item.notes) + '</div>';
      }
      h += '</a>';
      return h;
    }

    function renderResults(items, query) {
      if (!items.length) {
        hideResultsPanel();
        return;
      }

      var shown = items.slice(0, MAX_NAV_RESULTS);
      var html = '<div class="header-search-results__grid" role="list">';
      shown.forEach(function (item) {
        html += renderResultCard(item);
      });
      html += '</div>';
      if (query) {
        html += '<div class="header-search-results__see-all">';
        html += '<a href="/search?q=' + encodeURIComponent(query) + '">See all results &rarr;</a>';
        html += '</div>';
      }

      resultsContainer.innerHTML = html;
      showResultsPanel();
    }

    function filterFragrances(query) {
      if (!query.trim()) {
        /* No query: hide results panel */
        hideResultsPanel();
        return;
      }

      var q = query.toLowerCase();
      var matches = fragrances.filter(function (f) {
        return f.name.toLowerCase().indexOf(q) !== -1 ||
               (f.notes && f.notes.toLowerCase().indexOf(q) !== -1) ||
               (f.tags && f.tags.toLowerCase().indexOf(q) !== -1);
      });

      /* No matches: show top 3 of all + hint */
      if (!matches.length) {
        var shown = fragrances.slice(0, MAX_NAV_RESULTS);
        var html = '<div class="header-search-results__empty">';
        html += '<div class="header-search-results__empty-title">No matches for "' + escapeHtml(query) + '"</div>';
        html += '</div>';
        html += '<div class="header-search-results__grid" role="list">';
        shown.forEach(function (item) {
          html += renderResultCard(item);
        });
        html += '</div>';
        html += '<div class="header-search-results__see-all">';
        html += '<a href="/search?q=' + encodeURIComponent(query) + '">See all results &rarr;</a>';
        html += '</div>';
        resultsContainer.innerHTML = html;
        showResultsPanel();
        return;
      }

      renderResults(matches, query);
    }

    /* Toggle buttons (desktop + mobile) */
    toggleBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (isOpen) {
          closeSearch();
        } else {
          openSearch();
        }
      });
    });

    /* Close button */
    if (searchClose) {
      searchClose.addEventListener('click', closeSearch);
    }

    /* Input filtering */
    searchInput.addEventListener('input', function () {
      filterFragrances(searchInput.value);
    });

    /* ESC key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) {
        closeSearch();
      }
    });

    /* Click outside to close */
    document.addEventListener('click', function (e) {
      if (!isOpen) return;
      /* Don't close if clicking inside search bar or results */
      if (searchBar.contains(e.target) || resultsContainer.contains(e.target)) return;
      /* Don't close if clicking a toggle button */
      var clickedToggle = false;
      toggleBtns.forEach(function (btn) {
        if (btn.contains(e.target)) clickedToggle = true;
      });
      if (clickedToggle) return;
      closeSearch();
    });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /* --- Helpers ------------------------------------------------- */
  function formatDate(d) {
    var y = d.getFullYear();
    var m = ('0' + (d.getMonth() + 1)).slice(-2);
    var day = ('0' + d.getDate()).slice(-2);
    return y + '-' + m + '-' + day;
  }

  function updateCartBadge() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var badges = document.querySelectorAll('[data-cart-count]');
        badges.forEach(function (badge) {
          badge.textContent = cart.item_count;
        });
        /* Show cart icons on homepage if they were hidden */
        if (cart.item_count > 0) {
          var hiddenDesktop = document.querySelector('.cart-icon--hidden');
          if (hiddenDesktop) hiddenDesktop.classList.remove('cart-icon--hidden');
          var hiddenMobile = document.querySelector('.mobile-cart-icon--hidden');
          if (hiddenMobile) hiddenMobile.classList.remove('mobile-cart-icon--hidden');
        }
      })
      .catch(function () { /* silently ignore */ });
  }
})();
